import safeStorage from './safeStorage';

const getScopedStorage = (windowRef) => {
  if (!windowRef) return null;
  try {
    return windowRef.localStorage;
  } catch {
    return null;
  }
};

export function initDesignMode(windowRef = (typeof window !== 'undefined' ? window : undefined), doc = (typeof document !== 'undefined' ? document : undefined)) {
  if (!windowRef || !doc) return;
  const root = doc.documentElement;
  const params = new URLSearchParams(windowRef.location?.search || '');
  const scopedStorage = getScopedStorage(windowRef);
  const get = (k, d) => {
    if (scopedStorage) {
      try { return scopedStorage.getItem(k) || d; } catch (e) { return d; }
    }
    return safeStorage.getItem(k) || d;
  };
  const set = (k, v) => {
    if (scopedStorage) {
      try { scopedStorage.setItem(k, v); return; } catch (e) {}
    }
    safeStorage.setItem(k, v);
  };

  // Always enable V2 design by default
  root.setAttribute('data-design-v2', '1');
  set('design-v2', '1');

  // Force forest brand as primary (ignore overrides)
  const brand = 'forest';
  root.setAttribute('data-brand', brand);
  set('design-brand', brand);

  const density = params.get('density') || get('design-density', 'default');
  root.setAttribute('data-density', density);
  set('design-density', density);
}

